import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import store from './store/store'
import UUID from 'vue-uuid'  
import router from './router/router';
import SuccessDialog from './components/SuccessDialog.vue';
import ErrorDialog from './components/ErrorDialog.vue';
import FormConfirmDialog from './components/FormConfirmDialog.vue';
import HeaderEmilia from './components/HeaderEmilia.vue';
import FooterEmilia from './components/FooterEmilia.vue';

import Calendar from 'v-calendar/lib/components/calendar.umd'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
//import OtpInput from "@bachdgvn/vue-otp-input";
import OtpInput from "./components/OtpInputCustom/OtpInput.vue";
import SingleOtpInput from "./components/OtpInputCustom/SingleOtpInput.vue";

import HttpInterceptor from './services/HttpInterceptor'

Vue.component('success-dialog', SuccessDialog);
Vue.component('error-dialog', ErrorDialog);
Vue.component('form-confirm-dialog', FormConfirmDialog);
Vue.component('header-emilia', HeaderEmilia);
Vue.component('footer-emilia', FooterEmilia);

Vue.component("v-otp-input", OtpInput);
Vue.component("SingleOtpInput", SingleOtpInput);
Vue.component("v-calendar", Calendar);
Vue.component("v-datepickercalendar", DatePicker);

Vue.use(UUID);  

Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
